import { c as _c } from "react/compiler-runtime";
import { ClientMode } from "@justhome/api-core";
import Layout from "../components/Layout";
import Qualification from "../components/Qualification";
import Loading from "../components/QualificationForm/Loading";
import { QualificationProvider } from "../context/context";
import useBookingParams from "../lib/hooks/useBookingParams";
interface QualificationPageProps {
  clientMode?: ClientMode;
  partnerId?: string;
}
const QualificationPage = t0 => {
  const $ = _c(12);
  const {
    clientMode,
    partnerId
  } = t0;
  const {
    isReady,
    lead,
    projectId,
    dealId,
    propertyId,
    contactId,
    skipQualification,
    emailFromQuery
  } = useBookingParams();
  if (!isReady) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Loading />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Layout><Qualification /></Layout>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== clientMode || $[3] !== contactId || $[4] !== dealId || $[5] !== emailFromQuery || $[6] !== lead || $[7] !== partnerId || $[8] !== projectId || $[9] !== propertyId || $[10] !== skipQualification) {
    t2 = <QualificationProvider lead={lead} projectId={projectId} dealId={dealId} clientMode={clientMode} partnerId={partnerId} propertyId={propertyId} contactId={contactId} skipQualification={skipQualification} emailFromQuery={emailFromQuery}>{t1}</QualificationProvider>;
    $[2] = clientMode;
    $[3] = contactId;
    $[4] = dealId;
    $[5] = emailFromQuery;
    $[6] = lead;
    $[7] = partnerId;
    $[8] = projectId;
    $[9] = propertyId;
    $[10] = skipQualification;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};
export default QualificationPage;